/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendScenarioDto } from '../../models/backend-scenario-dto';
import { BackendScenarioRequestDto } from '../../models/backend-scenario-request-dto';

export interface ProjectCalculationsVariantsKitsUpdate$Params {
  id: number;
  body: BackendScenarioRequestDto;
}

export function projectCalculationsVariantsKitsUpdate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectCalculationsVariantsKitsUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendScenarioDto>> {
  const rb = new RequestBuilder(rootUrl, projectCalculationsVariantsKitsUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendScenarioDto>;
    }),
  );
}

projectCalculationsVariantsKitsUpdate.PATH = '/api/project_calculations/variants_kits/{id}/';
